import { useEffect, useState } from 'react'

/**
 * True once the window has scrolled past `threshold` px (default 4, so a
 * 1-2px settle after a route change doesn't flip the sticky navbar). Shared by
 * the Navbar, the home SearchBar and the home map shell so they agree on the
 * exact same frame instead of running three scroll listeners with three
 * thresholds.
 *
 * Hysteresis: true past `threshold`, false again only back at the top. The stuck
 * home SearchBar is shorter, so scroll anchoring pulls scrollY back by that much;
 * a single threshold then flips back and forth forever (nav jittering up/down).
 */
export default function useScrolled(threshold = 4) {
    const [isScrolled, setIsScrolled] = useState(() => window.scrollY > threshold)

    useEffect(() => {
        const handleScroll = () => setIsScrolled((was) => window.scrollY > (was ? 0 : threshold))

        handleScroll() // check initial position

        window.addEventListener('scroll', handleScroll, { passive: true })

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [threshold])

    return isScrolled
}
